module.exports = __webpack_public_path__ + "static/favicon-16x16-060fe999f96101b9361c073adbb1cce9.png";